<script>
  import {
    get_song_structure,
  } from "../../../../pkg/song_format.js";
  import { initWasm } from "$lib/extensions/lib/wasmInit.js";
  import {
    buildSyntaxHighlightedHTML,
    parseSongStructureSafe,
  } from "$lib/extensions/lib/songUtils.js";

  let {
    code,
    filename,
    mode = "auto",
  } = $props();

  // Track system prefers-color-scheme for auto mode
  let systemDark = $state(
    typeof window !== "undefined" && window.matchMedia("(prefers-color-scheme: dark)").matches
  );

  $effect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = (e) => { systemDark = e.matches; };
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  });

  const dark = $derived(mode === "dark" || (mode === "auto" && systemDark));

  let highlightedHTML = $state("");
  let wasmReady = $state(false);

  $effect(async () => {
    await initWasm();
    wasmReady = true;
    rebuild();
  });

  $effect(() => {
    const _code = code;
    if (!wasmReady) return;
    rebuild();
  });

  function rebuild() {
    const result = parseSongStructureSafe(get_song_structure, code);
    highlightedHTML = buildSyntaxHighlightedHTML(
      code,
      result.notesGrouped,
      result.structure?.instruments || []
    );
  }
</script>

<div class={"w-full h-full border overflow-hidden " + (dark ? "border-[#3a3a4a] bg-black" : "border-gray-300 bg-white")}>
  {#if filename}
    <div class={"flex items-center gap-2 px-4 py-2 border-b " + (dark ? "bg-black border-[#3a3a4a]" : "bg-gray-100 border-gray-300")}>
      <span class="text-[#7ec699] text-xs">▸</span>
      <span class={"text-xs " + (dark ? "text-[#8a8a94]" : "text-gray-500")}>{filename}</span>
    </div>
  {/if}
  <div class="p-4 font-mono text-xs overflow-auto w-full h-full">
    <pre class={"leading-relaxed w-full " + (dark ? "text-white" : "text-black")}>{@html highlightedHTML}</pre>
  </div>
</div>
